import React, { useMemo } from "react";

const BAR_COUNT = 7;

export default function ProgressBar({percentage}) {
    const quartilePercentage = 100 / BAR_COUNT;
    const truePercent = percentage;

    const COLOR_STOPS = [
        "#ff0000", // Red
        "#ff704d", // Red-Orange
        "#ff8c42", // Orange
        "#ffa726", // Light Orange
        "#ffff00", // Yellow-Orange
        "#a5d6a7", // Light Green
        "#66bb6a", // Green
    ];

    const getSegmentColor = (segmentIndex, fillPercent = 1) => {
        if (segmentIndex < 1 || segmentIndex > BAR_COUNT) return COLOR_STOPS[0];

        const colorIndex = segmentIndex - 1;

        if (fillPercent === 1) {
            // Fully filled - use solid color
            return COLOR_STOPS[colorIndex];
        }

        // Partially filled - create gradient from color to next color
        const startColor = COLOR_STOPS[colorIndex];
        const nextColorIndex = Math.min(colorIndex + 1, COLOR_STOPS.length - 1);
        const endColor = COLOR_STOPS[nextColorIndex];

        // For smooth transition within a segment
        return `linear-gradient(90deg, 
            ${startColor} 0%, 
            ${startColor} ${fillPercent * 5}%, 
            ${endColor} ${fillPercent * 100}%, 
            ${endColor} 100%
        )`;
    };


    const rangeArray = useMemo(() => {
        let elementArr = [];
        let root = document.documentElement;
        let percent;
        let quartileValue;

        for (let i = 1; i <= BAR_COUNT; i++) {
            const currentPoint = Math.round(quartilePercentage * i);

            if (truePercent <= currentPoint) {
                //Check if percent and quartile value is present of not. This runs only one time
                if (!percent && !quartileValue) {
                    const previousPoint = Math.round(quartilePercentage * (i - 1));
                    const difference = currentPoint - previousPoint;
                    quartileValue = i;

                    percent = `${Math.round(
                        ((truePercent - previousPoint) / difference) * 100
                    )}%`;
                }

                if (percent && quartileValue) {
                    if (i === quartileValue) {
                        //set specified block value so that it can be used to make gradient
                        root.style.setProperty(`--block-${i}`, '100%');
                        //set left value to position the indicator and tooltip
                        root.style.setProperty(`--left-value`, percent);
                    }

                    const segmentPercent = i === quartileValue ? parseFloat(percent) : currentPoint;
                    //Push element with class filled and current into array
                    elementArr.push(
                        <div
                            className={`item ${i === quartileValue ? "current filled" : "filled"}`}
                            key={i}
                            data-content={`${percentage}%`}
                            style={{background: getSegmentColor(i, segmentPercent/100)}}
                        >
                        </div>
                    );
                }
            } else {
                root.style.setProperty(`--block-${i}`, "100%");
                elementArr.push(
                    <div className="item filled" key={i}
                         style={{background: getSegmentColor(i, parseFloat(currentPoint)/100)}}
                    />);
            }
        }
        return elementArr;
    }, [quartilePercentage, truePercent]);

    return (
        <div className="App">
            <div className="potential__range">
                <div className="range">{rangeArray}</div>
            </div>
        </div>
    );
}